import React, { Component } from 'react';

class Footer extends Component {
  renderSocialLinks(networks) {
    if (!Array.isArray(networks)) {
      return null;
    }

    return networks.map(function(network) {
      return (
        <a
          className="link-chip footer-chip"
          href={network.url}
          key={network.name}
          target={network.url && network.url.indexOf('mailto:') === 0 ? undefined : '_blank'}
          rel={network.url && network.url.indexOf('mailto:') === 0 ? undefined : 'noreferrer'}
          aria-label={network.label || network.name}
        >
          {network.label || network.name}
        </a>
      );
    });
  }

  render() {
    var data = this.props.data || {};
    var currentYear = new Date().getFullYear();

    return (
      <footer className="site-footer">
        <div>
          <a className="brand-mark" href="#home" aria-label="Back to top">
            RT
          </a>
          <p>{data.name} - {data.occupation}</p>
        </div>

        <div className="footer-socials">
          {this.renderSocialLinks(data.social)}
        </div>

        <p className="copyright">Copyright {currentYear}. Built with care in Perth.</p>
      </footer>
    );
  }
}

export default Footer;
